"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/story/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = exports.StyledMarqueeItem = exports.StyledMarquee = exports.ImageWithText = exports.Image = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactFastMarquee = _interopRequireDefault(require("react-fast-marquee"));

var _typography = require("@titelmedia/bricks-theme/lib/utilities/typography");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var StyledMarqueeItem = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));

exports.StyledMarqueeItem = StyledMarqueeItem;
var StyledMarquee = (0, _styledComponents.default)(_reactFastMarquee.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  /* Remove a blank space if the vw > sum of images width */\n  .marquee {\n    min-width: initial;\n  }\n"])));
exports.StyledMarquee = StyledMarquee;

var Text = _styledComponents.default.p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  text-transform: ", ";\n  line-height: 1em;\n  ", ";\n"])), function (props) {
  return (0, _typography.setFont)({
    bold: props.bold,
    display: !props.bold
  });
}, function (props) {
  return props.bold ? 'uppercase' : 'none';
}, function (props) {
  return (0, _typography.setFontSizes)({
    mobile: props.bold ? '48px' : '48px',
    tablet_vertical: props.bold ? '100px' : '100px',
    tablet_horizontal: props.bold ? '100px' : '100px'
  });
});

exports.Text = Text;

var Image = _styledComponents.default.img(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  max-height: 50vh;\n  padding-left: 15px;\n\n  @media (min-width: 992px) {\n    max-height: 50vh;\n  }\n"])));

exports.Image = Image;

var ImageWithText = _styledComponents.default.img(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  max-height: 60px;\n  padding: 0px 8px;\n\n  margin-top: ", ";\n\n  @media (min-width: 768px) {\n    max-height: 90px;\n    padding: 0px 16px;\n  }\n\n  @media (min-width: 992px) {\n    max-height: 120px;\n  }\n"])), function (props) {
  return props.bold ? '8px' : '-4px';
});

exports.ImageWithText = ImageWithText;